type Props = {
  extensions?: Array<string>;
  file: File;
  maxFileSize: number;
};

const allowedDefaultExtensions = [
  'image/png',
  'image/jpeg',
  'image/jpeg',
  'video/quicktime',
  'video/mp4',
  'video/avi',
  'text/plain',
];

export const validateFile = ({
  file,
  extensions = allowedDefaultExtensions,
  maxFileSize,
}: Props) => {
  return {
    isValidExtension: extensions.includes(file.type),
    isValidSize: file.size <= maxFileSize,
  };
};
